/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useFormContext } from '@jalik/react-form'
import { toUpper } from 'lodash'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function getEstateReference (transactionType: TransactionType, estateType: EstateType, estateId: number): string {
  let ref = ''

  // Append transaction type.
  if (transactionType) {
    ref += transactionType
  }
  // Append category code.
  if (estateType) {
    ref += estateType
  }
  // Append estate ID.
  ref += estateId
  return ref
}

function EstateReferenceField (props: FormTextFieldProps) {
  const { name = 'reference', ...others } = props
  const intl = useIntl()
  const { values, setValue } = useFormContext()

  useEffect(() => {
    if (values.type && values.id && values.transaction) {
      const ref = getEstateReference(
        values.transaction,
        values.type,
        values.id
      )

      if (ref !== values[name]) {
        setValue(
          name,
          getEstateReference(values.transaction, values.type, values.id)
        )
      }
    }
  }, [setValue, values.type, values.id, values.transaction, values, name])

  return (
    <FormField
      label={intl.formatMessage({
        id: 'reference',
        defaultMessage: 'Référence'
      })}
      name={name}
      parser={toUpper}
      title={intl.formatMessage({
        id: 'estate_ref_help',
        defaultMessage: 'Référence unique basée sur la transaction, le type et le numéro (ex: VT1 = Vente Terrain).'
      })}
      {...others}
    />
  )
}

export default EstateReferenceField
